import { useState } from 'react';
import { useGetLmsTrainingCatalogsQuery } from '../../../../api';

/**
 * Eğitim Kataloğu liste/filtre/sayfalama state ve veri hook'u.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §3.
 *
 * Ekleme/güncelleme/silme mutasyonları artık burada değil — düzenleme sayfası kendi hook'unu
 * kullanıyor (bkz. `createEditForm/hook/useTrainingCatalogMutations.js`), liste sayfasının kendisi
 * (`index.jsx`) artık bir CRUD formuna doğrudan bağlı değil (claim modülündeki liste/detay hook
 * ayrımıyla aynı desen).
 */
const useTrainingCatalogData = () => {
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 10, page: 1 });
    const [activeFilters, setActiveFilters] = useState({ trainingCode: '', trainingName: '', vehicleModel: '', trainingType: '', trainingLocation: '', isActive: null });

    const {
        data: trainingCatalogApi,
        isLoading,
        isFetching,
        error
    } = useGetLmsTrainingCatalogsQuery(
        {
            trainingCode: activeFilters.trainingCode || undefined,
            trainingName: activeFilters.trainingName || undefined,
            vehicleModel: activeFilters.vehicleModel || undefined,
            trainingType: activeFilters.trainingType || undefined,
            trainingLocation: activeFilters.trainingLocation || undefined,
            isActive: activeFilters.isActive === 0 || activeFilters.isActive === 1 ? activeFilters.isActive : undefined,
            pageNumber: lazyParams.page,
            pageSize: lazyParams.rows
        },
        { refetchOnMountOrArgChange: true }
    );

    const onPage = (event) => {
        setLazyParams((prev) => ({
            ...prev,
            page: event.page + 1,
            first: event.first,
            rows: event.rows
        }));
    };

    const handleFilterChange = (updated) => {
        setActiveFilters({
            trainingCode: updated.trainingCode || '',
            trainingName: updated.trainingName || '',
            vehicleModel: updated.vehicleModel || '',
            trainingType: updated.trainingType || '',
            trainingLocation: updated.trainingLocation || '',
            // 0 (Pasif) geçerli bir seçim olduğu için `|| ''` gibi falsy-düşürücü bir kalıp kullanılmıyor.
            isActive: updated.isActive === 0 || updated.isActive === 1 ? updated.isActive : null
        });
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    };

    const initFilters = () => {
        setActiveFilters({ trainingCode: '', trainingName: '', vehicleModel: '', trainingType: '', trainingLocation: '', isActive: null });
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    };

    return {
        trainingCatalogApi: trainingCatalogApi || { items: [], totalCount: 0 },
        isLoading,
        isFetching,
        error,
        lazyParams,
        onPage,
        activeFilters,
        handleFilterChange,
        initFilters
    };
};

export default useTrainingCatalogData;
